// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"PoweredBy_poweredBy__12hGC","companyLogo":"PoweredBy_companyLogo__JWMte","isMobile":"PoweredBy_isMobile__3aSu8","downloadButton":"PoweredBy_downloadButton__3Cy85"};